export const ActiveItem = 'bg-lightGrey text-gray-900'
export const MenuItem = 'flex items-center justify-between pr-4 hover:bg-lightGrey px-4 py-3 text-sm first:rounded-t-md last:rounded-b-md focus:outline-none'
export const Button = 'hover:bg-lightGrey w-full text-left px-4 py-3 text-sm first:rounded-t-md last:rounded-b-md focus:outline-none'

export const RoundedActiveItem = {
    full: 'rounded-md',
    bottom: 'rounded-b-md',
    top: 'rounded-t-md',
    none: '',
}
